<template>
  <div class="article-similar px-md-9 px-0">
    <card v-for="card in news" :key="card.id" :card="card" max />
    <!-- <pre>{{news}}</pre> -->
  </div>
</template>

<script>
import card from './../ArticleCard'
export default {
  components: {
    card,
  },
  props: {
    article_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      news: [],
    }
  },
  created() {
    this.getArticles()
  },
  methods: {
    /**
     * Получение списка новостей.
     * Получает 4 новости, проверяет, есть ли в полученных та новость, которая открыта сейчас.
     * Если есть, то убирает её из списка и выводит 3 оставшихся новости.
     * Если нет, тогда обрезает полученный массив новостей до 3 и выводит 3 оставшихся.
     */
    async getArticles() {
      this.news = await this.$store
        .dispatch('getArticles', { limit: 4, params: "readingroom" })
        .then(res => {
          const news = res
            .filter(card => card.lang_versions[1].content_id !== this.article_id)
            .filter(card => card.is_posted_reading_room)

          return news.length > 3 ? news.slice(0, news.length - 1) : news
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
